export function esIOSWebView() {
    const ua = window.navigator.userAgent;
    return /iPad|iPhone|iPod/.test(ua) && !window.MSStream && window.flutter_inappwebview;
  }